import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { ProcessorDetails } from '@/lib/api/processors'

interface ProcessorOptionsCardProps {
    processor: ProcessorDetails
}

const renderValue = (value: unknown): string => {
    if (value === null || value === undefined) {
        return 'N/A'
    }
    if (typeof value === 'boolean') {
        return value ? 'Yes' : 'No'
    }
    if (typeof value === 'object') {
        return JSON.stringify(value, null, 2)
    }
    return String(value)
}

export const ProcessorOptionsCard = ({ processor }: ProcessorOptionsCardProps) => {
    const { t } = useTranslation('processors')

    const options = processor.options || {}
    const optionEntries = Object.entries(options)

    if (optionEntries.length === 0) {
        return null
    }

    return (
        <Card>
            <CardHeader>
                <CardTitle>{t('configuration')}</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 gap-4">
                    {optionEntries.map(([key, value]) => (
                        <div key={key} className="border-b pb-4 last:border-b-0 last:pb-0">
                            <p className="text-sm text-muted-foreground capitalize">
                                {key.replace(/([A-Z])/g, ' $1').trim()}
                            </p>
                            <p className="font-mono text-sm mt-1 break-all">
                                {renderValue(value)}
                            </p>
                        </div>
                    ))}
                </div>
            </CardContent>
        </Card>
    )
}

